import { fromUnixTime, getUnixTime } from "date-fns/esm";

import { ScheduledDelete, ScheduledDeleteInput } from "types/generated";

import { StackManageScheduledDeleteFormFields } from "./types";

export const getFormDefaultValues = (
  defaultDateTime: Date,
  integration?: ScheduledDelete
): StackManageScheduledDeleteFormFields => ({
  shouldDeleteResources: integration?.shouldDeleteResources ?? false,
  dateTime: integration?.timestampSchedule
    ? fromUnixTime(integration.timestampSchedule)
    : defaultDateTime,
  timezoneDisplay: "local",
});

export const mapCreateFormData = (
  values: StackManageScheduledDeleteFormFields
): ScheduledDeleteInput => ({
  shouldDeleteResources: values.shouldDeleteResources,
  timestampSchedule: getUnixTime(values.dateTime),
  cronSchedule: null,
  timezone: null,
});
